import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import server from "../../api/server";

const AboutUsIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: " عنا ",
				breadcrumb: "المعلومات",
				button: {
					show: false,
					text: "اضافة معلومة جديدة",
					link: "/siteinfo/aboutUs/create",
				},
			})
		);
		try {
			const pageData = await server(cookie).get("/pages/about-us");
			setData(pageData.data.data.page.sections);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	// const handleDelete = postID => {
	// 	axios
	// 		.delete(
	// 			`${process.env.REACT_APP_API_URL}/pages/about-us/sections/${postID}`,
	// 			{
	// 				headers: {
	// 					Authorization: `Bearer ${cookie.get("token")}`,
	// 					Accept: "application/json",
	// 				},
	// 			}
	// 		)
	// 		.then(function (response) {
	// 			onStart();
	// 		})
	// 		.catch(function (error) {
	// 			toast.error("خطأ، برجاء المحاولة لاحقا!");
	// 		});
	// };

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<section>
			{loading && <Loader />}
			<section>
				<div className="row">
					{data.map(post => (
						<div className="col-md-3" key={post.slug}>
							<div className="serviceItem">
								{/* <button onClick={() => handleDelete(post.slug)}>
									<i className="fas fa-trash"></i>
								</button> */}
								<Link to={`/siteinfo/aboutUs/show/${post.slug}`}>
									<img
										src={`${process.env.REACT_APP_MAIN_URL}/${post.image}`}
										alt={post.sectionTitle.ar ?? ""}
									/>
									<h1>{post.sectionTitle?.ar ?? ""}</h1>
									<p>{post.description?.ar ?? ""}</p>
								</Link>
							</div>
						</div>
					))}
				</div>
			</section>
		</section>
	);
};

export default AboutUsIndex;
